import { render } from "./ObjectTemplateApproval.vue?vue&type=template&id=9858a88e"
import script from "./ObjectTemplateApproval.vue?vue&type=script&lang=js"
export * from "./ObjectTemplateApproval.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.21.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__